import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Routes } from '@/router';

const currentYear = new Date().getFullYear();

@Component({
  name: 'CmgSustainabilityStatsPageLink',
})
export default class CmgSustainabilityStatsPageLink extends Vue {
  get currentYear() {
    return currentYear;
  }

  get doodleBackground() {
    return this.$appStore.state.cms.images.backgrounds.foodprint.default;
  }

  onClickSustainabilityLink() {
    this.$router.push({ name: Routes.CmgSustainabilityStatsPage });
    this.$services.ui.setModalVisibility('account', false);
  }
}
